"use client";

import { useState } from "react";
import { Play } from "lucide-react";
import { VideoModal } from "@/shared/components/ui/VideoModal";

const VIDEO_SRC = "https://www.youtube.com/embed/jJgJSn85BIw";

export function WalkthroughButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className="btn btn-ghost"
        onClick={() => setOpen(true)}
      >
        <Play className="h-4 w-4" fill="currentColor" strokeWidth={0} aria-hidden="true" />
        Walk through an example
      </button>
      <VideoModal
        isOpen={open}
        onClose={() => setOpen(false)}
        src={VIDEO_SRC}
      />
    </>
  );
}